var cilCoffee = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M191.5,376h97A111.627,111.627,0,0,0,400,264.5V248h24a72,72,0,0,0,0-144H80V264.5A111.627,111.627,0,0,0,191.5,376ZM400,136h24a40,40,0,0,1,0,80H400Zm-288,0H368V264.5A79.589,79.589,0,0,1,288.5,344h-97A79.589,79.589,0,0,1,112,264.5Z' class='ci-primary'/><rect width='480' height='32' x='16' y='416' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilCoffee };

